import { defineMessages } from 'react-intl'

export default defineMessages({
  successTitle: {
    id: 'editExpenseLineItemPresenter.successTitle',
    defaultMessage: 'Item saved',
  },
  errorTitle: {
    id: 'editExpenseLineItemPresenter.errorTitle',
    defaultMessage: "Item couldn't be saved",
  },
  errorMessage: {
    id: 'editExpenseLineItemPresenter.errorMessage',
    defaultMessage: 'Failed to save item',
  },
})
